import _ from 'lodash';
import { connect } from 'react-redux';
import { fetchBlogItems } from 'client/actions/blog';
import { smsKey } from 'routes/tax/components/constants';

import TaxLandingPage from './taxLandingPage';

const mapStateToProps: Object = state => ({
  blogPosts: _.get(state, 'blog.sections.taxes', []).slice(0, 3),
  contentfulData: state.contentfulData || {},
  smsKey,
  smsSuccess: _.find(state.sms.received, { key: smsKey }),
});

export default connect(mapStateToProps, {
  fetchBlogItems,
})(TaxLandingPage);
